import {
  ContentList,
  ContentTable,
  Dropdown,
  FaqList,
  ImageBlock,
  LinkButton,
  OrderedList,
  ServiceOptions,
  Text,
  Video,
} from '../components/ContentPages';

export const COMPONENT_TYPES = {
  TYPOGRAPHY: 'typography',
  LIST: 'list',
  TABLE: 'table',
  FAQ: 'faq',
  SERVICE_OPTIONS: 'service-options',
  IMAGE_BLOCK: 'image-block',
  DROPDOWN: 'dropdown',
  BUTTON: 'button',
  VIDEO: 'video',
  ORDERED_LIST: 'ordered-list',
};

export const COMPONENT_HASH = {
  [COMPONENT_TYPES.TYPOGRAPHY]: Text,
  [COMPONENT_TYPES.LIST]: ContentList,
  [COMPONENT_TYPES.TABLE]: ContentTable,
  [COMPONENT_TYPES.SERVICE_OPTIONS]: ServiceOptions,
  [COMPONENT_TYPES.IMAGE_BLOCK]: ImageBlock,
  [COMPONENT_TYPES.DROPDOWN]: Dropdown,
  [COMPONENT_TYPES.FAQ]: FaqList,
  [COMPONENT_TYPES.BUTTON]: LinkButton,
  [COMPONENT_TYPES.VIDEO]: Video,
  [COMPONENT_TYPES.ORDERED_LIST]: OrderedList,
};
